module.exports = __webpack_public_path__ + "media/images/mindset/content-image-mobile-cd1263dd6d74a4f44afbaf171e597ba7.png";